import React from 'react';
import styles from './styles/Footer.sass';

class Footer extends React.Component {
  render() {
    return (
      <footer className={styles.footer}>
        <img
          src={require('images/footer.jpg')}
          alt='footer'
        />
      </footer>
    );
  }
}

export default Footer



// WEBPACK FOOTER //
// src/components/common/Footer.js